{
  "hero": {
    "liveBadge_one": "{{count}} competition open now",
    "liveBadge_other": "{{count}} competitions open now",
    "title": "Meet the NAPAICP competition platform",
    "description": "From registration and team formation to submissions, judging, and publishing results, NAPAICP is a one-stop experience for running a competition, and it also supports shuttle booking, on-site check-in and meal replies for conferences. This page gives you the quick tour; for exactly how each role operates day to day, head to Getting Started.",
    "primaryCta": "Sign in",
    "secondaryCta": "Get Started"
  },
  "quickNav": {
    "label": "On this page",
    "features": "Features",
    "roles": "Roles",
    "notices": "Things to know",
    "team": "Platform Development Team"
  },
  "features": {
    "heading": "Platform features",
    "multiCompetition": {
      "title": "Many competitions, fully isolated",
      "description": "Each competition manages its own teams, submissions, and permissions independently, so the platform can run several competitions at once."
    },
    "dynamicForms": {
      "title": "Custom registration & submission forms",
      "description": "Every competition can design its own registration and submission fields, with published versions kept as historical records."
    },
    "rubricJudging": {
      "title": "Standardized judging",
      "description": "Judges score against a rubric the organizer defines, with clear assignments and conflict-of-interest handling built in."
    },
    "resultsAudit": {
      "title": "Transparent, traceable results",
      "description": "Result calculation, locking, and publishing are all recorded; any adjustment shows who made it, when, and why."
    },
    "events": {
      "title": "On-site event services",
      "description": "Beyond competitions, it supports free shuttle booking with QR check-in, meal and banquet replies, notices and a help desk for conferences; registration and payment stay with the official registration system.",
      "cta": "About the events platform"
    }
  },
  "roles": {
    "heading": "Three roles, three entry points",
    "description": "The platform gives each role its own interface. Pick a role below to see its detailed steps.",
    "student": {
      "title": "Student",
      "description": "Register, form a team, fill out forms, upload and submit your work, and track scoring and results."
    },
    "judge": {
      "title": "Judge",
      "description": "Review assigned work (shown only as an anonymous code), score it against the rubric, and submit your scores."
    },
    "admin": {
      "title": "Organizer",
      "description": "Create the competition, design its forms and categories, assign judges, and publish results once judging is done."
    },
    "viewSteps": "See the steps"
  },
  "notices": {
    "heading": "Things to know",
    "account": "Sign-in options depend on what's currently enabled: email/password registration always works, and if the login page shows a \"Sign in with Google\" button, you can sign in with your Google account too.",
    "schedule": "Each competition's own page is the source of truth for its registration, submission, and judging windows; the homepage only lists what's currently public.",
    "dataHandling": "Submission files are uploaded privately and only ever accessed through short-lived signed URLs; judges never see a team's or student's real identity while scoring.",
    "support": "If you run into trouble, check Getting Started first; if that doesn't resolve it, contact the competition's organizer.",
    "events": "Event pages (Events in the main navigation) are separate from competitions: book the shuttle with just an email and check in with a ride QR; rider and meal data are deleted 30 days after the event."
  },
  "team": {
    "visitSite": "Visit {{name}}'s website",
    "orgs": {
      "napai": {
        "name": "MOE Advanced AI Talent Cultivation Program: Agentic AI and Embodied AI Curriculum (NAPAI)"
      },
      "ai4x": {
        "name": "Advanced Research Center for Cross-Disciplinary AI, National Taipei University (NTPU AI4X)"
      },
      "moe-ite": {
        "name": "Department of Information and Technology Education, Ministry of Education"
      },
      "ncu": {
        "name": "National Central University"
      },
      "ntpu": {
        "name": "National Taipei University"
      },
      "nthu": {
        "name": "National Tsing Hua University"
      }
    }
  },
  "cta": {
    "heading": "Ready to get started?",
    "description": "Sign in and the platform will take you to the area that matches your role.",
    "architectureCta": "Technical architecture"
  }
}
